import React from 'react';
import {render} from 'react-dom';

import {MEDAL_TABLE} from '../modules/olympics/constants/medal-table';
import MedalTable from '../modules/olympics/medal-table';
import SportsList from '../modules/olympics/sports-list';

render(
  <SportsList
    list={window.Site.olympics.sportsList}
    domain={window.Site.domain}
    themeColor='#002560'
  />,
  document.querySelector('.js-sports-list')
);

render(
  <MedalTable mockData={MEDAL_TABLE} />,
  document.querySelector('.js-medal-table')
);
